import ReactCodesInput from './ReactCodesInput';
if (typeof window !== 'undefined') {
  (<any>window).ReactCodesInput = ReactCodesInput;
}

export default ReactCodesInput;
